import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GameJoin from './components/GameJoin';
import GameView from './components/GameView';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/game/:gameId/join" element={<GameJoin />} />
          <Route path="/game/:gameId" element={<GameView />} />
          <Route path="/" element={
            <div>
              <h1>Quiz Game</h1>
              <p>Welcome to the Quiz Game!</p>
            </div>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
